import React from 'react';
import { useSelector } from 'react-redux';
import { Modal, List, Button } from 'antd';

const mergeResultsModal = ({ rootContainer, showModal, okCallback }) => {
  const mergeFromFormResult = useSelector((state) => state.reverseMapping.mergeFromFormResult);

  return (
    <Modal
      title="Merge Results"
      open={showModal}
      getContainer={rootContainer}
      centered
      width={1200}
      onOk={okCallback}
      onCancel={okCallback}
      okText="Save"
      footer={[
        <Button key="submit" type="primary" onClick={okCallback}>
          Ok
        </Button>,
      ]}
    >
      <List size="small" bordered dataSource={mergeFromFormResult} renderItem={(item) => <List.Item>{item}</List.Item>} />
    </Modal>
  );
};

export default mergeResultsModal;
